import './CustomCard.css';

export const CustomCard = ({ title, value, single = false }) => {
    const formattedValue =
        typeof value === 'number' ? value.toLocaleString('pt-BR') : value;

    return (
        <div className={`custom-card ${single ? 'custom-card--single' : ''}`}>
            <div className="custom-card__title">{title}</div>
            <div className="custom-card__divider" />
            <div className="custom-card__value">{formattedValue}</div>
        </div>
    );
};
